import Vue from 'vue';
import axios from 'axios';
import VanNoticeDialog from '@/components/common/NoticeDialog.vue';
import { Loading, Message, MessageBox } from 'element-ui';

let logoutFlag = false;

const utils = {
  noop() {},
  log(data, type) {
    /* eslint-disable */
    window.console[type || 'log'](data);
  },
  use(components) {
    const res = {};
    Object.keys(components).forEach((key) => {
      const component = components[key];
      res[component.name] = component;
    });
    return res;
  },
  message(message, type) {
    Message({
      type : type || 'info',
      message,
    });
  },
  success(message) {
    Message.success(message);
  },
  error(message) {
    Message.error(message);
  },
  warning(message) {
    Message.warning(message);
  },
  info(message) {
    Message.info(message);
  },
  alert(message, title = '提示', options = {}) {
    return new Promise((resolve) => {
      /* eslint-disable */
      MessageBox
        .alert(message, title, options)
        .then(resolve, resolve);
    });
  },
  confirm(message, title, options) {
    return MessageBox.confirm(message, title || '提示', {
      confirmButtonText: options && options.confirm || '确定',
      cancelButtonText: options && options.cancel || '取消',
      type: options && options.type || '',
      dangerouslyUseHTMLString: true,
      showClose: options && options.showClose || false,
      closeOnClickModal: options && options.closeOnClickModal || false,
    });
  },
  prompt(title, message, pattern, error) {
    const options = {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      closeOnPressEscape: false,
    };
    if (pattern) {
      options.inputPattern = pattern;
      if (error) {
        options.inputErrorMessage = error;
      }
    }
    return MessageBox.prompt(message, title, options);
  },
  redirect(url) {
    window.location.href = url;
  },
  clone(data) {
    if (this.isObject(data)) {
      return JSON.parse(JSON.stringify(data));
    } else {
      return data;
    }
  },
  debounce(fn, delay) {
    let timer = null;
    return function handler() {
      const context = this;
      const args = arguments;

      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  },
  throttle(func, delay) {
    let prev = Date.now();
    return function () {
      const context = this;
      const args = arguments;
      const now = Date.now();
      if (now - prev >= delay) {
        func.apply(context, args);
        prev = Date.now();
      }
    };
  },
  timeToSeconds(time) {
    let totalSeconds = 0;
    if (time) {
      const times = time.split(':');
      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (times.length === 3) {
        hours = times[0] * 1;
      }
      minutes = times[times.length - 2] * 1;
      seconds = times[times.length - 1] * 1;

      if (hours) {
        minutes += hours * 60;
      }
      if (minutes) {
        seconds += minutes * 60;
      }
      totalSeconds = seconds;
    }
    return totalSeconds;
  },
  secondsToTime(totalSeconds) {
    let time = '';
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    seconds = totalSeconds;

    hours = Math.floor(seconds / (60 * 60));
    if (hours) {
      seconds = seconds % (60 * 60);
    }
    minutes = Math.floor(seconds / 60);
    if (minutes) {
      seconds = seconds % 60;
    }

    if (hours) {
      if (hours < 10) {
        time = '0';
      }
      time += hours;
      time += ':';
    }
    if (minutes < 10) {
      time += '0';
    }
    time += minutes;
    time += ':';
    if (seconds < 10) {
      time += '0';
    }
    time += seconds;

    return time;
  },
  fromJson(data) {
    return JSON.parse(data);
  },
  toJson(data) {
    return JSON.stringify(data);
  },
  storage(key, data) {
    /* eslint-disable */
    if(key === 'token' || key === 'account') {
      if(typeof data === 'undefined') {
        const value =  sessionStorage.getItem(key);
        try {
          return JSON.parse(value);
        } catch(e) {
          return value;
        }
      } else {
        if(data !== null) {
          sessionStorage.setItem(key, this.isString(data) ? data : JSON.stringify(data));
        } else {
          sessionStorage.removeItem(key);
        }
        return null;
      }
    }
    const localStorage = window.localStorage;
    if (typeof data === 'undefined') {
      const value = localStorage.getItem(key);
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    } else {
      if (data !== null) {
        localStorage.setItem(key, this.isString(data) ? data : JSON.stringify(data));
      } else {
        localStorage.removeItem(key);
      }
    }
    return null;
  },
  cookie(name, value, options) {
    /* eslint-disable */
    if (this.isUndefined(value)) {
      // read
      const rCookie = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
      const matchs = document.cookie.match(rCookie);
      if(matchs) {
        return decodeURIComponent(matchs[2]);
      }
      return null;
    } else if (value) {
      // write
      const days = options && options.expires || 30;
      let expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      let cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toGMTString()}`;
      if (options) {
        if (options.domain) {
          cookie = `${cookie};domain=${options.domain}`;
        }
        if (options.path) {
          cookie = `${cookie};path=${options.path}`;
        }
      }
      document.cookie = cookie;
    } else {
      // delete
      const expires = new Date();
      expires.setTime(expires.getTime() - 1);
      const val = this.cookie(name);
      let cookie = `${name}=${val};expires=${expires.toGMTString()}`;
      if(val != null) {
        cookie= `${name}=${val};expires=${expires.toGMTString()}`;
        if (options) {
          if (options.domain) {
            cookie = `${cookie};domain=${options.domain}`;
          }
          if (options.path) {
            cookie = `${cookie};path=${options.path}`;
          }
        }
        document.cookie= cookie;
      }
    }
  },
  loading(target, text) {
    return Loading.service({
      target: target || null,
      fullscreen: !target,
      lock: !target,
      text: text || '',
    });
  },
  popNotice(options) {
    const silent = utils.storage(options.businessKey);
    if (silent) return;
    const VanNoticeDialogConstructor = Vue.extend(VanNoticeDialog);
    const instance = new VanNoticeDialogConstructor({
      el: document.createElement('div'),
      data: options,
    });
    instance.$watch('createNoticeSilent', (value) => {
      utils.storage(options.businessKey, Number(value));
    });
    instance.open(options)
    return instance;
  },
  Loading: {
    instances: Object.create(null),
    show(target, text) {
      if (!(target in this.instances)) {
        this.instances[target] = Loading.service({
          target: target || null,
          fullscreen: !target,
          lock: !target,
          text: text || '',
        });
      }
    },
    hide(target) {
      if (target in this.instances) {
        this.instances[target].close();
        delete this.instances[target];
      } else {
        Object.keys(this.instances).forEach(key => this.hide(key));
      }
    },
  },
  Array: {
    findIndex(array, value, key, startIndex) {
      let index = -1;

      for (let i = startIndex || 0; i < array.length; i += 1) {
        const item = array[i];
        if (key && item[key] === value[key]) {
          index = i;
          break;
        } else if (item === value) {
          index = i;
          break;
        }
      }

      return index;
    },
    exist(array, value, key) {
      const index = this.findIndex(array, value, key);

      return index !== -1;
    },
    existArray(array, part, key) {
      let isAll = true;
      if (part) {
        for (let i = 0; i < part.length; i += 1) {
          const value = part[i];
          if (!this.exist(array, value, key)) {
            isAll = false;
            break;
          }
        }
      }
      return part && part.length && isAll;
    },
    find(array, value, key) {
      const index = this.findIndex(array, value, key);

      if (index !== -1) {
        return array[index];
      } else {
        return undefined;
      }
    },
    unipush(array, value, key) {
      if (!this.exist(array, value, key)) {
        array.push(value);
      }
    },
    pushReplace(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key)
      }
      array.push(value);
    },
    remove(array, value, key) {
      const index = this.findIndex(array, value, key);

      if (index !== -1) {
        array.splice(index, 1);
      }
    },
    removeAll(array, value, key, startIndex) {
      let index;
      while (index !== -1) {
        index = this.findIndex(array, value, key, startIndex);
        if (index !== -1) {
          array.splice(index, 1);
        }
      }
    },
    toggle(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key);
      } else {
        array.push(value);
      }
    },
    toggleArray(array, part, key) {
      if (this.existArray(array, part, key)) {
        part.forEach(value => this.remove(array, value, key));
      } else {
        part.forEach(value => this.unipush(array, value, key));
      }
    },
    concat(array, part, index) {
      if (utils.isUndefined(index)) {
        index = array.length;
      }
      array.splice(index, 0, ...(utils.isArray(part) ? part : [part]));
    },
    toMatrix(array, rows, cols) {
      const matrix = [];
      for (let i = 0; i < rows; i += 1) {
        matrix[i] = [];
        for (let j = 0; j < cols; j += 1) {
          matrix[i][j] = array[i * cols + j];
        }
      }
      return matrix;
    },
    getArrEqual(arr1, arr2) {
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    getArrRepeatNumber(array, value, key) {
      let number = 0;
      for (let i = 0; i < array.length; i += 1) {
        if (array[i][key] === value[key]) {
          number += 1;
        }
      }
      return number;
    },
    sum(numbers) {
      return numbers.reduce((total, num) => (total + num));
    },
    groupBy(array, key) {
      const keyData = Array.from(new Set(array.map(item => item[key])));
      return keyData.map(value => array.filter(item => item[key] === value));
    },
    flattenDeep(array) {
      return array.reduce((acc, val) => Array.isArray(val) ? acc.concat(this.flattenDeep(val)) : acc.concat(val), []);
    },
  },
  Date: {
    format(date, formatExp) {
      let result = formatExp;
      if (utils.isDate(date)) {
        const years = String(date.getFullYear());
        const months = date.getMonth() + 1;
        const days = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const milliseconds = date.getMilliseconds();
        const spans = [
          {
            key: 'yyyy',
            value: years,
          },
          {
            key: 'yy',
            value: years.substr(-2),
          },
          {
            key: 'MM',
            value: utils.leftPad(months, '0', 2),
          },
          {
            key: 'M',
            value: months,
          },
          {
            key: 'dd',
            value: utils.leftPad(days, '0', 2),
          },
          {
            key: 'd',
            value: days,
          },
          {
            key: 'HH',
            value: utils.leftPad(hours, '0', 2),
          },
          {
            key: 'H',
            value: hours,
          },
          {
            key: 'mm',
            value: utils.leftPad(minutes, '0', 2),
          },
          {
            key: 'm',
            value: minutes,
          },
          {
            key: 'ss',
            value: utils.leftPad(seconds, '0', 2),
          },
          {
            key: 's',
            value: seconds,
          },
          {
            key: 'S',
            value: utils.leftPad(milliseconds, '0', 3),
          },
        ];
        for (let i = 0; i < spans.length; i += 1) {
          const span = spans[i];
          result = result.replace(new RegExp(span.key, 'g'), span.value);
        }
      }
      return result;
    },
  },
  leftPad(value, pad, length) {
    value = String(value);
    while (value.length < length) {
      value = pad + value;
    }
    return value;
  },
  title(title) {
    document.title = title;
  },
  login({
    token,
    account,
  }) {
    logoutFlag = false;
    // sessionStorage.setItem('token', token);
    utils.storage('token', token);
    utils.storage('account', account);
    axios.defaults.headers.common['Authorization'] = token || '';
  },
  logout(url) {
    utils.storage('token', '');
    utils.storage('account', null);
    utils.storage('WKHint', 0);
    /* eslint-disable */
    let domain;
    if (!window.location.port) {
      const names = window.location.host.split('.');
      domain = `.${names[names.length - 2]}.${names[names.length - 1]}`;
    } else {
      // local dev
      domain = 'dev.passion.vanthink.cn';
    }
    utils.cookie('token', null, { domain, path: '/' });

    // 兼容teacher登出
    const rh = /teacher\/student\-info/;
    if(rh.test(location.href)) {
      window.location.href = `${url || ''}/#/teacher/login`;
    }else {
      window.location.href = `${url || ''}/#/login`;
    }
  },
  isLogin() {
    return !!utils.storage('token');
  },
  params(key) {
    const params = Object.create(null);

    /* eslint-disable */
    const query = window.location.href.indexOf('?') >= 0 ? window.location.href.split('?')[1] : '';
    if (query) {
      const values = query.split('&');
      let pairs;
      for (const i in values) {
        pairs = values[i].split('=');
        params[pairs[0]] = pairs.length ? decodeURIComponent(pairs[1]) : '';
      }
    }

    if (this.isString(key)) {
      if (key in params) {
        return params[key];
      } else {
        return null;
      }
    } else {
      return params;
    }
  },
  getApiPath(url) {
    if (/^\/api\//i.test(url)) {
      /* eslint-disable */
      const host = window.location.host;
      if (/^www\.xxzx\.vip$/i.test(host)) {
        return `https://www.xxzx.vip${url}`;
      } else if (/^test-passion-bxg\.vanthink\.cn$/i.test(host)) {
        return `https://test-passion-bxg.vanthink.cn${url}`;
      } else if (/^teachresearch-passion\.vanthink\.cn/.test(host)) {
        return `https://teachresearch-passion.vanthink.cn${url}`;
      } else if (/dev-\S+-branch-\S+\.vanthink\.cn/.test(host)) {
        const SERVER_BRANCH_NAME = 'master';
        return `https://${host}/pname-passion_backend-branch-${SERVER_BRANCH_NAME}${url}`;
      } else if (/^dev\.passion\.vanthink\.cn$/i.test(host)) {
        return `https://dev.passion.vanthink.cn${url}`;
      }
    }
    return url;
  },
  getPassionTeacherUrl(url) {
    const host = window.location.host;

    if (/^www\.xxzx\.vip$/i.test(host)) {
      return `https://teacher.wx.xxzx.vip/#/${url}`;
    } else if (/^www\.bxgxxzx\.vip$/i.test(host)) {
      return `https://teacher.wx.xxzx.vip/#/${url}`;
    } else if (/^test-passion-bxg\.vanthink\.cn$/i.test(host)) {
      return `https://test-passion-teacher-wx.vanthink.cn/#/${url}`;
    } else if (/^teachresearch-passion\.vanthink\.cn/.test(host)) {
      return `https://test-passion-teacher-wx.vanthink.cn/#/${url}`;
    } else if (/^dev\.passion\.vanthink\.cn$/i.test(host)) {
      return `https://dev-passion-teacher-wx.vanthink.cn/#/${url}`;
    }

    return `https://teacher.wx.xxzx.vip/#/${url}`;
  },
  jsonify(obj) {
    const clone = {};
    if (obj) {
      Object.keys(obj).forEach((key) => {
        if (this.isObject(obj[key])) {
          clone[key] = this.toJson(obj[key]);
        } else {
          clone[key] = obj[key];
        }
      });
    }
    return clone;
  },
  get(url, params, loading, { showErrorMessage = true } = {}) {
    const self = this;

    let options = {};
    let target;
    let loadingInstance;

    if (self.isObject(params)) {
      if ('params' in params) {
        options = params;
        params = options.params;
      } else {
        options.params = params;
      }
      options.params = self.jsonify(options.params);
    } else if (params) {
      loading = params;
    } else {
      loading = false;
    }
    if (loading) {
      if (self.isBoolean(loading)) {
        target = undefined;
      } else {
        target = loading;
      }
      loadingInstance = self.loading(target);
    }

    return new Promise((resolve, reject) => {
      Vue
        .http
        .get(self.getApiPath(url), options)
        .then(res => {
          if (loadingInstance) {
            loadingInstance.close();
          }
          if (res.headers['x-redirect-to']) {
            const { code } = url === 'graphql' ? JSON.parse(res.data.errors[0].message) : res.data;
            if (code === 44) {
              utils.storage('token', '');
              utils.storage('account', null);
            }
            utils.redirect(res.headers['x-redirect-to']);
            return;
          }
          if (res.data.errors && res.data.errors.length) {
            if (/^\{[\S\s]+\}$/.test(res.data.errors[0].message)) {
              const { code, message } = JSON.parse(res.data.errors[0].message);
              if (code === 44 && !logoutFlag) {
                logoutFlag = true;
                utils
                  .alert(message)
                  .then(() => {
                    utils.logout();
                  });
              } else {
                if (showErrorMessage) {
                  utils.error(message);
                }
              }
              reject({ code, message });
            } else {
              reject(res.data);
            }
          } else if (res.data.code) {
            if (res.data.code === 44 && !logoutFlag) {
              logoutFlag = true;
              utils
                .alert(res.data.message)
                .then(() => {
                  utils.logout();
                });
            } else {
              if (showErrorMessage) {
                utils.error(res.data.message);
              }
            }
            reject(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch((error) => {
          if (loadingInstance) {
            loadingInstance.close();
          }
          utils.error('系统繁忙，请稍后重试');

          reject(error);
        });
    });
  },
  post(url, data, loading, { showErrorMessage = true } = {}) {
    const self = this;

    let options = {};
    let target;
    let loadingInstance;

    if (self.isObject(data)) {
      if ('data' in data) {
        options = data;
        data = options.data;
      }
      data = self.jsonify(data);
    } else if (data) {
      loading = data;
      data = null;
    } else {
      loading = false;
      data = null;
    }
    if (loading) {
      if (self.isBoolean(loading)) {
        target = undefined;
      } else {
        target = loading;
      }
      loadingInstance = self.loading(target);
    }
    return new Promise((resolve, reject) => {
      Vue
        .http
        .post(self.getApiPath(url), data, options)
        .then(res => {
          if (loadingInstance) {
            loadingInstance.close();
          }
          if (res.headers['x-redirect-to']) {
            const { code } = url === 'graphql' ? JSON.parse(res.data.errors[0].message) : res.data;
            if (code === 44) {
              utils.storage('token', '');
              utils.storage('account', null);
            }
            utils.redirect(res.headers['x-redirect-to']);
            return;
          }
          if (res.data.errors && res.data.errors.length) {
            if (/^\{[\S\s]+\}$/.test(res.data.errors[0].message)) {
              const { code, message } = JSON.parse(res.data.errors[0].message);
              if (code === 44 && !logoutFlag) {
                logoutFlag = true;
                // 这里老师登录，登出有很大问题,logout 里修改
                utils
                  .alert(message)
                  .then(() => {
                    utils.logout();
                  });
              } else {
                if (showErrorMessage) {
                  utils.error(message);
                }
              }
              reject({ code, message });
            } else {
              reject(res.data);
            }
          } else if (res.data.code) {
            if (res.data.code === 44 && !logoutFlag) {
              logoutFlag = true;
              utils
                .alert(res.data.message)
                .then(() => {
                  utils.logout();
                });
            } else {
              if (showErrorMessage) {
                utils.error(res.data.message);
              }
            }
            reject(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(() => {
          if (loadingInstance) {
            loadingInstance.close();
          }
          utils.error('系统繁忙，请稍后重试');

          reject();
        });
    });
  },
  isUndefined(value) {
    return typeof value === 'undefined';
  },
  isBoolean(value) {
    return typeof value === 'boolean';
  },
  isObject(value) {
    return value !== null && typeof value === 'object';
  },
  isFunction(value) {
    return typeof value === 'function';
  },
  isString(value) {
    return typeof value === 'string';
  },
  isArray(value) {
    return Array.isArray(value);
  },
  isNumber(value) {
    return typeof value === 'number';
  },
  isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
  },
  isJson(str) {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str);
        return typeof obj == 'object' && obj
      } catch(e) {
        return false;
      }
    }
  },
  // 全角转半角
  toCDB(str) {
    let tmp = '';
    let charCode;
    for (let i = 0; i < str.length; i += 1) {
      charCode = str.charCodeAt(i);
      if (charCode === 12288) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
        continue;
      }
      if (charCode > 65248 && charCode < 65375) {
        tmp += String.fromCharCode(charCode - 65248);
      } else {
        tmp += String.fromCharCode(charCode);
      }
    }
    return tmp;
  },
  toNumber(str) {
    let tmp;
    let charCode;
    if (!str) return str;
    if (str.length === 1) {
      charCode = str.charCodeAt(0);
      // 将①～⑳转化成 数字1～20
      if (charCode >= 9312 && charCode <= 9331) {
        tmp = charCode - 9311;
      }
      // 将⑴～⒇转化成 数字1～20
      if (charCode >= 9332 && charCode <= 9351) {
        tmp = charCode - 9331;
      }
    } else if (/\(\d+\)|（\d+）|（\d+\)|\(\d+）/.test(str)) {
      tmp = str.replace(/\(|\)|（|）/g, '');
    } else if (str.length > 1) {
      tmp = str;
      for (let i = 0; i < str.length; i++) {
        const letter = str[i];
        charCode = letter.charCodeAt(0)
        // 将①～⑳转化成 数字1～20
        if (charCode >= 9312 && charCode <= 9331) {
          tmp = tmp.replace(letter, `${charCode - 9311}`);
        }
        // 将⑴～⒇转化成 数字1～20
        if (charCode >= 9332 && charCode <= 9351) {
          tmp = tmp.replace(letter, `${charCode - 9331}`);
        }
      }
    }
    return tmp ? tmp.toString() : str;
  }
};

export default utils;
